import { createSelector } from 'reselect'

export const selectTOCs = (state) => state.tocs.list || []

export const selectTOCByMarketingCarrier = (marketingCarrier) => createSelector(
    selectTOCs,
    (tocs) => tocs?.find(toc => toc.attributes.code === marketingCarrier)
)
